// Import Actions
import { getFlagApplicantId, SET_SESSION_FLAGS, SET_APPLICANT_FLAGS } from './FlagActions';
import { LOGOUT_USER } from '../User/AuthActions';

// Initial State
export const initialState = {
    data: [], // [ { session: 'session1', flags: [....] } ] // Ordered by sessions
};

const FlagReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_SESSION_FLAGS:
            return {
                ...state,
                data: [
                    ...state.data.filter(sessionFlagsData => sessionFlagsData.session !== action.sessionId),
                    {
                        session: action.sessionId,
                        flags: action.flags,
                    },
                ],
            };

        case SET_APPLICANT_FLAGS: {
            const targetSessionFlagsData = state.data.find(sessionFlagsData => sessionFlagsData.session === action.sessionId) || { session: action.sessionId, flags: [] };

            return {
                ...state,
                data: [
                    ...state.data.filter(sessionFlagsData => sessionFlagsData.session !== action.sessionId),
                    {
                        ...targetSessionFlagsData,
                        flags: [
                            ...(targetSessionFlagsData.flags || []).filter(flag => getFlagApplicantId(flag) !== action.applicantId),
                            ...action.flags,
                        ],
                    },
                ],
            };
        }

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default FlagReducer;
